export default __webpack_public_path__ + "static/media/task.6d54d8c8.svg";